module.exports = __webpack_public_path__ + "static/media/15.12ee96bd.jpg";